import { useLang } from "@/lib/i18n";

const FIELDS = [
  { k: "first_name", label: "Prénom", auto: "given-name", half: true },
  { k: "last_name", label: "Nom", auto: "family-name", half: true },
  { k: "email", label: "Email", auto: "email", type: "email" },
  { k: "phone", label: "Téléphone", auto: "tel", type: "tel" },
  { k: "address", label: "Adresse", auto: "address-line1" },
  { k: "address2", label: "Complément (facultatif)", auto: "address-line2", optional: true },
  { k: "zip", label: "Code postal", auto: "postal-code", half: true },
  { k: "city", label: "Ville", auto: "address-level2", half: true },
];

export const EMPTY_CUSTOMER = { first_name: "", last_name: "", email: "", phone: "", address: "", address2: "", zip: "", city: "", country: "FR" };

export function customerErrors(c) {
  const e = {};
  FIELDS.forEach((f) => { if (!f.optional && !String(c[f.k] || "").trim()) e[f.k] = "Requis"; });
  if (c.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(c.email)) e.email = "Email invalide";
  if (c.phone && c.phone.replace(/\D/g, "").length < 6) e.phone = "Numéro invalide";
  if (c.zip && !/^[0-9A-Za-z \-]{2,10}$/.test(c.zip)) e.zip = "Code postal invalide";
  return e;
}

export function CustomerForm({ value, onChange, errors, showErrors }) {
  const { t } = useLang();
  return (
    <div data-testid="checkout-customer-form" className="grid grid-cols-2 gap-3">
      {FIELDS.map((f) => (
        <label key={f.k} className={f.half ? "col-span-1" : "col-span-2"}>
          <span className="mb-1 block text-xs uppercase tracking-[0.16em] text-[var(--muted)]">{t(f.label)}</span>
          <input
            data-testid={`checkout-input-${f.k}`}
            type={f.type || "text"}
            autoComplete={f.auto}
            value={value[f.k]}
            onChange={(e) => onChange({ ...value, [f.k]: e.target.value })}
            className={`h-12 w-full rounded-sm border bg-[var(--ink)] px-3 text-base text-[var(--parchment)] outline-none transition-colors focus:border-[var(--gold)] ${showErrors && errors[f.k] ? "border-red-400" : "border-[var(--line)]"}`}
          />
          {showErrors && errors[f.k] ? <span data-testid={`checkout-error-${f.k}`} className="mt-1 block text-xs text-red-300">{t(errors[f.k])}</span> : null}
        </label>
      ))}
    </div>
  );
}
